// removed by extract-text-webpack-plugin
module.exports = {"sm":"only screen and (min-width: 48em)","xsmall":"only screen and (min-width: 375px)","small":"only screen and (min-width: 481px)","medium":"only screen and (min-width: 768px)","large":"only screen and (min-width: 993px)","xlarge":"only screen and (min-width: 1201px)","phoneOverlap":"85px","container":"container-qUqw4","top":"top-2oTyC","middle":"middle-3PRVG","yearInReview":"yearInReview-yPi_e","bottom":"bottom-AKhs7","middleContainer":"middleContainer-3pkax","wide":"wide-10rGW","auth":"auth-xuoRH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/layout/_layout.css
// module id = 159
// module chunks = 1